<div class="add-performance-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="add-performance-modal" role="dialog" aria-modal="true" aria-labelledby="addPerformanceTitle">
    <div class="add-performance-header">
      <div>
        <h2 id="addPerformanceTitle" class="add-performance-title">Add performance</h2>
        <div class="add-performance-sub">Create a new weekly performance</div>
      </div>
      <button type="button" class="add-performance-close" aria-label="Close" (click)="cancel()">×</button>
    </div>

    <div class="add-performance-content">
      <tm1-banner *ngIf="saveError" appearance="error" class="add-performance-banner">{{ saveError }}</tm1-banner>

      <div class="add-performance-form">
      <div class="field-group">
        <label for="performanceDescription" class="field-label">Description</label>
        <input
          id="performanceDescription"
          class="form-control"
          type="text"
          placeholder="e.g. Rd 9: Brisbane Lions v Carlton"
          [(ngModel)]="description"
          name="performanceDescription" />
      </div>

      <div class="field-row">
        <div class="field-group">
          <label for="performanceDate" class="field-label">Date</label>
          <input
            id="performanceDate"
            class="form-control"
            type="date"
            [(ngModel)]="date"
            name="performanceDate" />
        </div>

        <div class="field-group">
          <label for="performanceTime" class="field-label">Start time</label>
          <input
            id="performanceTime"
            class="form-control"
            type="time"
            [(ngModel)]="time"
            name="performanceTime" />
        </div>
      </div>

      <tm1-typography type="body-s" class="tz-note" *ngIf="venueTimezone">
        Time is interpreted in the venue timezone: <b>{{ venueTimezone }}</b>.
      </tm1-typography>
      <tm1-typography type="body-s" class="tz-note" *ngIf="!venueTimezone">
        Venue has no timezone set — time will be interpreted as UTC.
      </tm1-typography>

      <tm1-banner *ngIf="validationError" appearance="warning" class="add-performance-banner">
        {{ validationError }}
      </tm1-banner>

      <div class="add-performance-actions">
        <button type="button" class="btn-modal btn-modal--ghost" [disabled]="saving" (click)="cancel()">Cancel</button>
        <button type="button" class="btn-modal btn-modal--primary" [disabled]="saving" (click)="save()">
          {{ saving ? 'Saving…' : 'Save performance' }}
        </button>
      </div>
      </div>
    </div>
  </div>
</div>
